import { useCallback, useMemo } from "react";
import { apiMain } from "@/common/services";
import { useFetch } from "@/common/hooks/useFetch";
import type { OnlyFansSource } from "@/common/services/types";

export const useOnlyFansCreators = (source: OnlyFansSource, count = 3, canRunRequest = true) => {
  const fetchAdCreators = useCallback(() => apiMain.getAdsCreators({ source, count }), []);
  const { data, isLoading } = useFetch(fetchAdCreators, canRunRequest);
  const adCreators = useMemo(() => data?.ads || [], [data]);

  return {
    adCreators,
    isLoading,
  };
};
